import React from "react";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import JsonParentTable from "../Apps/Workflow/components/JsonTable";

function ModalInitialDataTab({ isLoading, executionDetails }) {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className="space-y-3 p-6">
                <div className="animate-pulse h-6 w-40 bg-gray-200 rounded" />
                <div className="animate-pulse h-32 bg-gray-200 rounded" />
            </div>
        );
    }

    const initialData = executionDetails?.data?.initialData;

    if (!initialData) {
        return (
            <div className="text-center py-8 text-gray-500">
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
                    <Badge variant="outline" className="mb-3">
                        <AlertCircle className="h-3 w-3 mr-1" />
                        {t("monitoring.modal.noInitialData")}
                    </Badge>
                    <p className="text-sm">{t("monitoring.modal.noInitialDataDesc")}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="pr-6 overflow-scroll h-full">
            <div className="space-y-6 p-4">
                <h3 className="font-medium text-lg mb-4">{t("monitoring.modal.initialData")}</h3>
                <p className="text-sm text-gray-600 mb-3">{t("monitoring.modal.initialDataDesc")}</p>
                <JsonParentTable data={initialData} />
            </div>
        </div>
    );
}

export default ModalInitialDataTab;
